import { useState, useEffect } from 'react';

/**
 * useDarkMode - 深色模式 Hook
 * 優先讀取 localStorage，若無則偵測系統偏好
 * 支援用戶手動切換並持久化
 */
export function useDarkMode() {
  const [isDark, setIsDarkState] = useState(() => {
    const stored = localStorage.getItem('darkMode');
    if (stored !== null) return stored === 'true';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    // 同步 <html> class 以讓 Tailwind dark mode 生效
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  useEffect(() => {
    // 監聽系統偏好變更（只在用戶未手動設定時生效）
    const stored = localStorage.getItem('darkMode');
    if (stored !== null) return; // 用戶已手動設定，不跟隨系統

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e) => setIsDarkState(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  const setIsDark = (value) => {
    localStorage.setItem('darkMode', String(value));
    setIsDarkState(value);
  };

  return { isDark, setIsDark };
}